"use client";

import { UiToaster } from "@frontend/roz-uikit";
import type { ComponentProps } from "react";

export type ToasterProps = ComponentProps<typeof UiToaster>;

export const Toaster = (props: ToasterProps) => (
  <UiToaster
    toastOptions={{ className: "sdkui:bg-white!" }}
    visibleToasts={1}
    {...props}
  />
);
